import { Button } from '../../atoms/Button';
import { Chip, ChipProps } from '../../atoms/Chip';
import { Typography } from '../../molecules/Typography';

interface iModalHeaderProps {
  title?: string;
  subtitle?: string;
  chip?: ChipProps;
  onClose?: () => void;
  type?: 'LiveEventDetail' | 'default';
}

function ModalHeader({
  title,
  subtitle,
  chip,
  onClose,
  type = 'default',
}: iModalHeaderProps) {
  const hasCloseButton = !!onClose;

  return (
    <div
      className={`flex items-center justify-between gap-4 p-4 ${
        type === 'LiveEventDetail' ? 'pb-0' : 'bg-color-lighter'
      }`}
    >
      <div className=''>
        <div className='flex items-center gap-sm'>
          {type === 'default' && (
            <Typography type='title' size='h3'>
              {title}
            </Typography>
          )}
          {type === 'LiveEventDetail' && (
            <Typography type='titleSection' size='h4'>
              {title}
            </Typography>
          )}

          {chip && <Chip {...chip} />}
        </div>
        <Typography type='titleSection' size='h6'>
          {subtitle}
        </Typography>
      </div>
      {hasCloseButton && (
        <Button
          variant='outlined'
          LeftIcon={'close'}
          onlyIcon
          onClick={onClose}
        />
      )}
    </div>
  );
}

export { ModalHeader };
